import { useEventBus } from '@vueuse/core';

export const useGoToBuildingBus = () => useEventBus<string>('go-to-building-mobile');
